import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import Fab from "@mui/material/Fab";
import Zoom from "@mui/material/Zoom";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import Dialog from "@mui/material/Dialog";
import EditIcon from "@mui/icons-material/Edit";

import EditIconButtons from "../../components/EditIconButtons";
import { useUpdateNoteMutation, useDeleteNoteMutation } from "./notesApiSlice";

function EditNoteArea(props) {
  const navigate = useNavigate();
  const [isExpandedEditArea, setExpandedEditArea] = useState(props.isExpanded);
  const [isNoteEdited, setNoteEdit] = useState(props.note);
  let latestUpdatedAt;
  if (isNoteEdited.updatedAt !== "" && isNoteEdited.updatedAt !== undefined) {
    const date = new Date(isNoteEdited.updatedAt);
    latestUpdatedAt = new Intl.DateTimeFormat("en-HK", {
      dateStyle: "short",
      timeStyle: "short",
    }).format(date);
  }
  const [updateNoteArea, { isSuccess: isUpdateSucess, reset: resetUpdate }] =
    useUpdateNoteMutation();
  const [deleteNoteArea, { isSuccess: isDelSuccess, reset: resetDel }] =
    useDeleteNoteMutation();
  function handleOnCloseEditArea() {
    setExpandedEditArea(false);
    navigate("..");
    props.handleOnClose();
  }

  function handleOnChange(event) {
    const { value, name } = event.target;
    setNoteEdit((preValue) => {
      return {
        ...preValue,
        [name]: value,
      };
    });
  }
  function onCancelLabelClicked(name) {
    let curLabels = isNoteEdited.labels;
    let newLabels = curLabels.filter((preItem) => {
      return preItem.name !== name;
    });
    setNoteEdit((preItems) => {
      return {
        ...preItems,
        labels: newLabels,
      };
    });
  }
  function editNoteAreaBgColour(color) {
    setNoteEdit((prevState) => {
      return {
        ...prevState,
        bgColour: color,
      };
    });
  }
  function editNoteAreaPinStatus(pin) {
    setNoteEdit((prevState) => {
      return {
        ...prevState,
        pinned: pin,
      };
    });
  }
  function editNoteAreaLabels(newLabels) {
    //let curLabels = isNoteEdited.labels;
    if (isNoteEdited.labels.some((e) => e._id === newLabels._id)) {
      const filteredLabels = isNoteEdited.labels.filter((preItem) => {
        return preItem._id !== newLabels._id;
      });
      setNoteEdit((prevState) => {
        return {
          ...prevState,
          labels: filteredLabels,
        };
      });
    } else {
      setNoteEdit((prevState) => {
        return {
          ...prevState,
          labels: [newLabels, ...prevState.labels],
        };
      });
    }
  }

  async function onUpdateNoteAreaClicked(event) {
    await updateNoteArea({ id: isNoteEdited._id, initialNote: isNoteEdited });
    event.preventDefault();
  }
  async function onDeleteNoteAreaClicked(event) {
    await deleteNoteArea({ id: isNoteEdited._id });
    event.preventDefault();
  }
  useEffect(() => {
    setNoteEdit(props.note);
    setExpandedEditArea(props.isExpanded);
  }, [props.note, props.isExpanded]);
  useEffect(() => {
    if (isUpdateSucess) {
      resetUpdate();
    }
    if (isDelSuccess) {
      resetDel();
    }
  }, [isUpdateSucess, isDelSuccess, navigate, resetUpdate, resetDel]);
  return (
    <Dialog
      id={`notes/${isNoteEdited._id}`}
      open={isExpandedEditArea}
      disableScrollLock
      onClose={handleOnCloseEditArea}
      maxWidth="xl"
      sx={{
        backdropFilter: "blur(3px) sepia(5%)",
        "& .MuiDialog-paper": {
          borderRadius: "15px",
          outline: "none",
          overflowX: "hidden",
          overflowY: "hidden",
        },
      }}
    >
      <form
        className="dialog-edit-note"
        style={{ background: isNoteEdited.bgColour }}
      >
        <input
          style={{ background: isNoteEdited.bgColour }}
          onChange={handleOnChange}
          name="title"
          placeholder="Title"
          value={isNoteEdited.title}
        />
        <textarea
          style={{ background: isNoteEdited.bgColour }}
          onChange={handleOnChange}
          name="content"
          rows={props.isExpanded ? 2 : 1}
          value={isNoteEdited.content}
        />
        <p>{latestUpdatedAt}</p>
        <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
          {isNoteEdited.labels?.length
            ? isNoteEdited.labels.map((e, i) => {
                return (
                  <Chip
                    key={i}
                    i={i}
                    size="medium"
                    label={e.name}
                    onDelete={() => onCancelLabelClicked(e.name)}
                  />
                );
              })
            : null}
        </Stack>
        {/*<time dateTime={date}>Latest edited At:{latestUpdatedAt}</time>*/}
        <EditIconButtons
          onBgColourClick={editNoteAreaBgColour}
          bgCol={isNoteEdited.bgColour}
          onPinClick={editNoteAreaPinStatus}
          pinStatus={isNoteEdited.pinned}
          onDelClick={onDeleteNoteAreaClicked}
          authorId={isNoteEdited.author_id}
          handleCheckedLabels={editNoteAreaLabels}
          labelsList={isNoteEdited.labels}
        />
        <Zoom in={props.isExpanded}>
          <Fab
            className="btn-edit"
            type="button"
            onClick={(e) => {
              onUpdateNoteAreaClicked(e);
            }}
          >
            <EditIcon />
          </Fab>
        </Zoom>
      </form>
    </Dialog>
  );
}

export default EditNoteArea;
